var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"app"}},[_c('Header',{attrs:{"name":"Схема отработки пластов в зоне геологических нарушений"}}),_c('Navbar'),_c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }